import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Messages";
import getToken from "app/api/getToken";

export const DELETE_MESSAGE_REQUEST = "DELETE_MESSAGE_REQUEST";
export const DELETE_MESSAGE_SUCCESS = "DELETE_MESSAGE_SUCCESS";
export const DELETE_MESSAGE_FAIL = "DELETE_MESSAGE_FAIL";

export const delMessage = (id: number) => (dispatch: any): any => {
  dispatch({ type: DELETE_MESSAGE_REQUEST });

  const token = getToken();

  return api
    .delMessage(token, id)
    .then((response: AxiosResponse) => {
      dispatch({ type: DELETE_MESSAGE_SUCCESS });
    })
    .catch(err => {
      dispatch({
        type: DELETE_MESSAGE_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
